<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center" mt-5>
        <h1>Introduce tu contraseña</h1>
      </v-flex>
      <v-flex xs12 sm6 offset-sm3 mt-3>
        <v-form v-model="valid" @submit.prevent="userSignInCall({ email, password })">
          <v-layout column>
            <v-flex>
              <v-alert type="error" dismissible v-if="error" v-model="alert">
                {{ error }}
              </v-alert>
            </v-flex>
            <v-flex>
              <v-text-field
                style=display:none
                name="email"
                label="E-mail"
                id="email"
                type="email"
                v-model="email"
                autocomplete="username email"
                required></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                name="password"
                label="Contraseña"
                id="password"
                type="password"
                v-model="password"
                autofocus
                autocomplete="current-password"
                :rules="[rules.fieldRequired, rules.min6]"
                required></v-text-field>
            </v-flex>
            <v-btn
              color="primary"
              type="submit"
              :disabled="!valid || isLoading"
              :loading="isLoading">{{title}}</v-btn>

            <v-flex xs12 class="text-xs-center" mt-5 v-if="!signup">
              <v-btn flat to="/reset_password">¿Has olvidado tu contraseña?</v-btn>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import rules from '@/utils/rules'

export default {
  data () {
    return {
      valid: false,
      password: '',
      alert: false,
      isLoading: false,
      rules
    }
  },
  computed: {
    ...mapGetters(['email', 'signup']),
    title () {
      return this.signup ? 'Registrarse' : 'Iniciar sesión'
    },
    error () {
      return this.$store.state.error
    }
  },
  methods: {
    ...mapActions(['userSignIn', 'userSignUp', 'updateUserPrivacy']),
    async userSignInCall (payload) {
      this.isLoading = true
      if (this.signup) {
        const ok = await this.userSignUp({...payload, email: this.email})
        if (ok) {
          // console.log(this.$refs.notifications)
          // this.$refs.notifications.$refs.activator.click()
          this.$router.replace({ name: 'Subscription' })
        }
      } else {
        const res = await this.userSignIn({...payload, email: this.email})
        console.log({res})
        if (res.sucess && res.uid) {
          const privacy = JSON.parse(localStorage.getItem('privacy'))
          const terms = JSON.parse(localStorage.getItem('terms'))
          this.updateUserPrivacy({ id: res.uid, privacy, terms })
        }
      }
      this.isLoading = false
    },
    recoverPassword () {
      this.$router.push({ name: 'RecoverPassword'})
    }
    // userSignInProviderCall (provider) {
    //   this.isLoading = true
    //   this.userSignInProvider(provider)
    //     .catch(() => {
    //       this.isLoading = false
    //     })
    // }
  },
  watch: {
    error (value) {
      if (value) {
        this.isLoading = false
        this.alert = true
      }
    },
    alert (value) {
      if (!value) {
        this.$store.commit('setError', null)
      }
    }
  }
}
</script>
